function updateBaseWidth () {
    const baseWidth = window.innerWidth
     if(baseWidth > 1800){
        document.documentElement.style.setProperty('--base-width', 1700);
    }
    else if(baseWidth>1600 && baseWidth <= 1800){
        document.documentElement.style.setProperty('--base-width', 1600);
    }else if(baseWidth>1440 && baseWidth <= 1600){
        document.documentElement.style.setProperty('--base-width', 1500);
    }else if(baseWidth>1024 && baseWidth <= 1440){
      document.documentElement.style.setProperty('--base-width', 1440);
    }else if(baseWidth > 768 && baseWidth <= 1024){
      document.documentElement.style.setProperty('--base-width', 1024);
    }else if(baseWidth<768){
      document.documentElement.style.setProperty('--base-width', 750);
    }



    if(baseWidth > 1920){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1920_size);
    }else if(baseWidth > 1820 && baseWidth <= 1920){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1820_size);
    }else if(baseWidth > 1720 && baseWidth <= 1820){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1720_size);
    }else if(baseWidth > 1620 && baseWidth <= 1720){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1620_size);
    }else if(baseWidth > 1520 && baseWidth <= 1620){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1520_size);
    }else if(baseWidth > 1420 && baseWidth <= 1520){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1440_size);
    }else if(baseWidth > 1320 && baseWidth <= 1420){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1320_size);
    }else if(baseWidth > 1220 && baseWidth <= 1320){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1220_size);
    }else if(baseWidth > 1120 && baseWidth <= 1220){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1120_size);
    }else if(baseWidth > 1025 && baseWidth <= 1120){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_1024_size);
    }else if(baseWidth > 900 && baseWidth <= 1025){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_900_size);
    }else if(baseWidth > 800 && baseWidth <= 900){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_800_size);
    }else if(baseWidth > 700 && baseWidth <= 800){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_768_size);
    }else if(baseWidth > 600 && baseWidth <= 700){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_668_size);
    }else if(baseWidth > 500 && baseWidth <= 600){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_568_size);
    }else if(baseWidth > 400 && baseWidth <= 500){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_468_size);
    }else if(baseWidth > 300 && baseWidth <= 400){
      document.documentElement.style.setProperty('--base-font', settings.digie_font_375_size);
    }else{
      document.documentElement.style.setProperty('--base-font', settings.digie_font_375_size);
    }
  



    const customEvent = new CustomEvent('baseWidthChange', { detail: baseWidth });
    document.dispatchEvent(customEvent);
  }
  updateBaseWidth()
  window.addEventListener('resize', updateBaseWidth)
  